import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=780b96de&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=780b96de&prod&lang=scss"
import style1 from "./FAQ.vue?vue&type=style&index=1&id=780b96de&prod&scoped=true&lang=css"
import style2 from "./FAQ.vue?vue&type=style&index=2&id=780b96de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780b96de",
  null
  
)

export default component.exports